import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Group, Tooltip, Text, Table } from '@mantine/core';
import { IconEdit, IconTrash } from '@tabler/icons-react';

import { useRemovePaymentType } from '../../api/removePaymentType';
import { paymentTypeTypes } from '../../types';
import { EditModal } from '../EditModal';

import { ConfirmModal } from '@/components/Modals/Confirm';

type BodyRowProps = {
  paymentType: paymentTypeTypes.PaymentType;
};

export const BodyRow = ({ paymentType }: BodyRowProps) => {
  const removePaymentType = useRemovePaymentType();

  return (
    <Table.Tr key={paymentType._id}>
      <Table.Td>
        <Text size="sm">{paymentType.name}</Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{paymentType.key}</Text>
      </Table.Td>
      <Table.Td>
        <Text opacity={0.5} size="xs">
          {paymentType.isPartial ? 'Частичная оплата' : 'Полная оплата'}
        </Text>
      </Table.Td>
      <Table.Td>
        <Group>
          <ActionIcon
            variant="filled"
            radius="md"
            onClick={() =>
              NiceModal.show(EditModal, {
                paymentTypeId: paymentType._id,
                initialValues: {
                  name: paymentType.name,
                  key: paymentType.key,
                  isPartial: paymentType.isPartial,
                },
              })
            }
          >
            <Tooltip label="Edit Payment Type">
              <IconEdit />
            </Tooltip>
          </ActionIcon>
          <ActionIcon
            variant="filled"
            color="red"
            radius="md"
            onClick={() =>
              NiceModal.show(ConfirmModal, {
                title: `Remove Payment Type (${paymentType.name})?`,
                onSuccess: () => removePaymentType.mutate({ _id: paymentType._id }),
              })
            }
          >
            <Tooltip label="Remove Payment Type">
              <IconTrash />
            </Tooltip>
          </ActionIcon>
        </Group>
      </Table.Td>
    </Table.Tr>
  );
};
